<template>
  <div ref="dg_state" class="inline-block inline-block-flex items-center t-[#646A73]">
    <span class="status-icon" :class="status"></span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "dg-state",

  data() {
    return {
      status: ""
    };
  },
  props: {
    value: [Number, String, Boolean]
  },
  watch: {
    value() {
      this.$nextTick(this.setValue);
    }
  },
  methods: {
    setValue() {
      let txt = this.$refs["dg_state"].innerText;

      if (txt.indexOf("成功") > -1 || txt.indexOf("通过") > -1 || txt.indexOf("已开") > -1 || txt.indexOf("启") > -1 || txt.indexOf("生效中") > -1 || txt.indexOf("已实名") > -1) {
        this.status = "success";
        return;
      }
      if (txt.indexOf("未开始") > -1 || txt.indexOf("等") > -1 || txt.indexOf("待") > -1 || txt.indexOf("中") > -1) {
        this.status = "wait";
        return;
      }
      if (txt.indexOf("已过期") > -1 || txt.indexOf("失败") > -1 || txt.indexOf("未") > -1 || txt.indexOf("关") > -1) {
        this.status = "fail";
        return;
      }

      this.status = "unknown";
    }
  },
  created() {
    if (this.map) {
      if (!isNaN(Number(this.status))) {
        this.status = this.map[this.status];
      }
    }
  },
  mounted() {
    this.$nextTick(this.setValue);
  }
};
</script>
<style scoped lang="less">
.status-icon {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d0d3d6;
  margin-right: 7px;

  // box-shadow: 0 0 5px 0px red;
  // 'success','fail','wait','unknown'
  &.unknown {
    background: #d0d3d6;
    // box-shadow: 0 0 5px 0px #d0d3d6;
  }

  &.success {
    background: #52c41a;
    // box-shadow: 0 0 5px 0px #52c41a;
  }

  &.fail {
    background: #f41717;
    // box-shadow: 0 0 5px 0px #f41717;
  }

  &.wait {
    background: #f9b957;
    // box-shadow: 0 0 5px 0px #f9b957;
  }
}
</style>
